module.exports = __webpack_public_path__ + "img/stena14.6672f176.jpg";